const Marquee = ({ items, dark = false, fast = false, className = "" }) => {
  const row = items.map((t, i) => (
    <span key={i} className="flex shrink-0 items-center gap-6 pr-6 md:gap-10 md:pr-10">
      <span className="font-display text-2xl font-black uppercase tracking-tight md:text-4xl">{t}</span>
      <span className={`h-2 w-2 rounded-full ${dark ? "bg-ember" : "bg-burgundy"}`} />
    </span>
  ));
  return (
    <div
      data-testid="marquee"
      className={`overflow-hidden border-y py-4 md:py-5 ${
        dark ? "border-white/10 bg-ink text-paper" : "border-ink/10 bg-paper text-ink"
      } ${className}`}
    >
      <div className={`flex w-max ${fast ? "animate-marquee-fast" : "animate-marquee"}`}>
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden>{row}</div>
      </div>
    </div>
  );
};

export default Marquee;
